import NavigationRegular from 'mini-fluent-svg-icons/lib/icons/NavigationRegular';
import NavigationUnreadRegular from 'mini-fluent-svg-icons/lib/icons/NavigationUnreadRegular';
import Strings from 'owa-strings/owa-mini-strings';
import type { HeaderIconType } from 'mini-header';

export const getHamburgerHeaderIcon = (
    iconReference,
    onClick,
    highlightHamburgerIcon
): HeaderIconType => ({
    icon: highlightHamburgerIcon ? NavigationUnreadRegular : NavigationRegular,
    iconRef: iconReference,
    onClick: onClick,
    ariaLabel: highlightHamburgerIcon
        ? Strings.folderNavigationActiveTipsButtonAriaLabel
        : Strings.folderNavigationButtonAriaLabel,
    ariaHasPopup: true,
});
